module.exports = __webpack_public_path__ + "img/img3.c65a9bd9.png";